import useFileSaver from '@hooks/useFileSaver';
import useRequest, { IDataRequest } from '@hooks/useRequest';
import { EnumEmpresa } from '@model/Empresa';
import { IRemessa } from '@model/Remessa';
import { IRemessaFatura } from '@model/RemessaFatura';
import { EnumRemessaStatus, IRemessaStatus } from '@model/RemessaStatus';
import React from 'react';

export interface IRemessaFilter {
    empresaId: EnumEmpresa
    descricao: string
    competencia: string
    remessaStatusId: EnumRemessaStatus
}

export interface IRemessaFaturaFilter {
}

const controller = "/Remessa";

export function useRemessaService () {
    const _request = useRequest();
    const fileSaver = useFileSaver();

    const listar = React.useCallback((request: IDataRequest<IRemessaFilter>) => {
        return _request.getData<IRemessa[]>(`${controller}/Listar`, request);
    }, [_request]);

    const listarItens = React.useCallback((remessaId: number, filter: IRemessaFaturaFilter) => {
        return _request.get<IRemessaFatura[]>(`${controller}/ListarItens/${remessaId}`, {
            params: filter
        })
    }, [_request]);

    const listarStatusAtivos = React.useCallback(() => {
        return _request.get<IRemessaStatus[]>(`${controller}/ListarStatusAtivos`);
    }, [_request]);

    const baixarArquivo = React.useCallback((remessaId: number) => {
        return _request.download(`${controller}/BaixarArquivo/${remessaId}`)
            .then(response => { 
                fileSaver.save(response, `remessa-${remessaId}.ret`);
            });
    }, [_request, fileSaver]);

    return React.useMemo(() => ({
        listar, listarItens, baixarArquivo, listarStatusAtivos
    }), [listar, listarItens, baixarArquivo, listarStatusAtivos])
}